<template>
    <div>
        <div class="chatList" v-loading='loading' v-if="to_user">
            <div v-if="to_user.type=='1'">
                <div class="zx_title">咨询订单</div>
                <div class="info_item">
                    <span class="info_tit">咨询类型：</span><span class="info_text">{{userdetail.inquiry_type_text}}</span>
                </div>
                <div class="info_item">
                    <span class="info_tit">咨询专家：</span><span class="info_text">{{userdetail.doc_name}}</span>
                </div>
                <div class="info_item">
                    <span class="info_tit">订单号：</span><span class="info_text">{{userdetail.order_num}}</span>
                </div>
                <div class="info_item">
                    <span class="info_tit">咨询人姓名：</span><span class="info_text">{{userdetail.patient_name}}</span>
                </div>
                <div class="info_item">
                    <span class="info_tit">咨询人性别：</span><span class="info_text">{{userdetail.patient_sex_text}}</span>
                </div>
                <div class="info_item">
                    <span class="info_tit">咨询人年龄：</span><span class="info_text">{{userdetail.patient_age}}岁</span>
                </div>
                <div class="info_item">
                    <span class="info_tit">金额：</span><span class="info_text">￥{{userdetail.pay_amount}}</span>
                </div>
                <div class="info_item">
                    <span class="info_text"></span>
                </div>

            </div>
            <div v-else>
                <div class="zx_title">商城订单</div>
                <div class="topgoods" v-for="(g,index) in userdetail.orderItems" :key="index">
                    <div class="pic">
                        <img :src="g.goods_item.cover" alt="">
                    </div>
                    <el-tooltip class="item" effect="dark" :content="g.goods_item.title" placement="top">
                        <div class="g_name">
                            {{g.goods_item.title}}
                        </div>
                    </el-tooltip>
                    <div class="price">
                        ￥{{g.price}}<br> ×{{g.num}}
                    </div>
                </div>
                <div class="user_info" v-if="userdetail">
                    <div class="jj"><span class="jj_tit">收件人：</span>{{userdetail.address.name}}</div>
                    <div class="jj"><span class="jj_tit">收件电话：</span>{{userdetail.address.phone}}</div>
                    <div class="jj"><span
                            class="jj_tit">收件地址：</span>{{userdetail.address.province}}/{{userdetail.address.city}}/{{userdetail.address.district}}{{userdetail.address.address}}
                    </div>

                    <div class="jj"><span class="jj_tit">订单号：</span>{{userdetail.no}}</div>
                    <div class="jj"><span class="jj_tit">订单状态：</span><span
                            :class="userdetail.closed==0?'o_state':'o_state2'">{{({0:'正常',1:'关闭'})[userdetail.closed]}}</span>
                    </div>
                    <div class="jj"><span class="jj_tit">支付金额：</span><span
                            :class="userdetail.closed==0?'o_state':'o_state2'">￥{{userdetail.pay_amount}}</span> </div>
                    <div class="jj"><span class="jj_tit">支付时间：</span><span
                            :class="userdetail.closed==0?'o_state':'o_state2'">{{userdetail.paid_time?date('Y-m-d H:i:s',userdetail.paid_time):'未支付'}}</span>
                    </div>
                    <div class="jj"><span class="jj_tit">支付积分：</span><span
                            :class="userdetail.closed==0?'o_state':'o_state2'">{{userdetail.pay_kcurrency}}</span></div>
                    <div class="jj"><span class="jj_tit">支付类型：</span><span
                            :class="userdetail.closed==0?'o_state':'o_state2'">{{userdetail.payment_method}}</span>
                    </div>
                </div>
                <div class="user_info" v-if="userdetail">
                    <div class="kk_tit">快递信息</div>
                    <div class="jj"><span
                            class="jj_tit">快递名称：</span>{{userdetail.ship_data?userdetail.ship_data.express_company:'未发货'}}
                    </div>
                    <div class="jj"><span
                            class="jj_tit">快递单号：</span>{{userdetail.ship_data?userdetail.ship_data.express_no:'未发货'}}
                    </div>
                    <div class="jj"><span
                            class="jj_tit">发货时间：</span>{{userdetail.ship_data?date('Y-m-d H:i:s',userdetail.ship_data.express_time):'未发货'}}
                    </div>

                </div>
            </div>
        </div>
        <div class="no_order" v-else>
            请选择用户或订单
        </div>
    </div>
</template>

<script>
    import {
        mapState
    } from 'vuex'

    export default {
        name: "chatList",
        props: ['to_user'],
        watch: {
            'to_user'(nVal, oVal) {}
        },
        data() {
            return {
                userdetail: '',
                loading: false,
                page: 0,
                curId: '',
                a: 1,
                // 总条数
                total: '',
                noMore: true,
                date: xaoi.date,

            }
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            }),
        },
        mounted() {
            let vue = this
        },
        created() {
            // this.getList()
        },
        methods: {
            getList() {
                if (!this.to_user) {
                    return false
                }
                this.loading = true
                axios.post('/admin/pc/KtUserChatlist/userOrderInfo', {
                    order_type: this.to_user.type,
                    order_id: this.to_user.order_id,
                }, {
                    token: true
                }).then(res => {
                    this.userdetail = res.data.data
                    this.loading = false;
                }).catch((error) => {
                    console.log(error);
                    // this.loading = false;
                })
            },

            // 选择
            selectUser(item) {
                // let vue = this
                // vue.$parent.page = 1
                // this.curId = item.id
                // vue.$emit('setDataId', item)
            },
        },
        destroyed() {
            // this.bus.$off()
        }
    }
</script>

<style lang="scss" scoped>
    .chatList {
        // width: 100%;
        height: 742px;
        padding: 10px;
        border-right: 1px solid #ECECEC;

        .topgoods {
            display: flex;
            align-items: center;
            margin-bottom: 20px;

            .pic {
                width: 50px;
                height: 50px;
                border-radius: 5%;
                overflow: hidden;
                border: 1px solid #e8e8e8;

                img {
                    width: 100%;
                    display: block;
                }
            }

            .g_name {
                margin-left: 10px;
                font-size: 14px;
                // font-weight: 600;
                margin-right: 5px;
                flex: 1;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                line-height: normal;
            }

            .price {
                color: red;
                width: 25%;
                font-size: 14px;
            }

            .sex {
                width: 20px;

                img {
                    width: 100%;
                }
            }
        }

        .user_info {
            padding: 0px 0 10px;

            .kk_tit {
                padding: 0 0 5px;
                font-weight: 600;
            }

            .jj {
                font-size: 14px;
                padding: 2px 0;

                .jj_tit {
                    font-size: 14px;
                    color: #999;
                }

                .o_state {
                    color: green;
                }

                .o_state2 {
                    color: red;
                }
            }
        }

        .team_hz {
            margin-top: 30px;
        }


        .team_user {
            .t_item {
                display: flex;
                align-items: center;
                padding: 5px 10px;

                .t_u_a {
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    overflow: hidden;

                    img {
                        width: 100%;
                        display: block;
                    }
                }

                .t_u_n {
                    margin-left: 10px;

                    .t_u_n_text_name {
                        font-size: 16px;
                    }

                    .t_u_n_text {
                        font-size: 12px;
                    }
                }
            }
        }

        .zx_title {
            padding: 10px 0 12px;
            font-size: 17px;
            font-weight: 600;
            text-align: center;
        }

        .info_item {
            padding: 2px 0;

            .info_tit {
                font-size: 15px;
                color: #999;
            }

            +.info_text {
                font-size: 15px;
            }
        }

    }

    .no_order {
        text-align: center;
        padding: 10px 0;
        color: #999;
        font-size: 14px;
    }
</style>